import { Injectable, SkipSelf } from '@angular/core';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { EnvService } from 'src/app/env.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ApiEndPointsCore } from '../../common/apiUrls/api-end-points-core';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  private baseUrl: any;
  private baseUrlTran: any;
  private baseUrlClm: any;
  private baseURlOrg: any;
  private baseUrlFilter: any;
  private baseUrlTask: any;
  private baseCoreUrl: any;

  constructor(private envService: EnvService, private _http: HttpClient,
    private apiAddress: ApiEndPointsCore, public env: EnvService,
    private constant: Constants) {
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrl = this.constant.ManageCoreportNumber;
    else
      this.baseUrl = this.env.apiUrl + this.constant.ManageCoreportNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlTran = this.constant.ManageTranscationportNumber;
    else
      this.baseUrlTran = this.env.apiUrl + this.constant.ManageTranscationportNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlClm = this.constant.CustomizedGridComponentPortNumber;
    else
      this.baseUrlClm = this.env.apiUrl + this.constant.CustomizedGridComponentPortNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseURlOrg = this.constant.ManageOrganizationPortNumber;
    else
      this.baseURlOrg = this.env.apiUrl + this.constant.ManageOrganizationPortNumber;

    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlFilter = this.constant.AuthPortNumber;
    else
      this.baseUrlFilter = this.env.apiUrl + this.constant.AuthPortNumber;

    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlTask = this.constant.ManageTask;
    else
      this.baseUrlTask = this.env.apiUrl + this.constant.ManageTask;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseCoreUrl = this.constant.ManageCoreportNumber;
    else
      this.baseCoreUrl = this.env.apiUrl + this.constant.ManageCoreportNumber;
  }

  // private baseUrl = this.constant.ManageCoreportNumber;
  //   // private baseUrl = this.env.apiUrl+this.constant.ManageCoreportNumber;
  //   //private baseUrlClm = this.env.apiUrl+this.constant.CustomizedGridComponentPortNumber;
  //   private baseUrlClm = this.constant.CustomizedGridComponentPortNumber;
  //   // private baseUrlTran = this.env.apiUrl+this.constant.ManageTranscationportNumber;
  //   private baseUrlTran = this.constant.ManageTranscationportNumber;
  //   private baseURlOrg=this.constant.ManageOrganizationPortNumber;
  //   //private baseURlOrg=this.env.apiUrl+this.constant.ManageOrganizationPortNumber;
  //   // private baseUrlFilter = this.env.apiUrl+this.constant.AuthPortNumber;
  //   private baseUrlFilter = this.constant.AuthPortNumber;

  getCoreList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getCoreListing;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getCoreFavoriteList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getFavoriteCoreListing;
    return this._http.post(apiURL, reqModel).pipe();
  }
  getCoreImportantList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getCoreImportantList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFilteredCoresList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.GetFilteredCores;
    return this._http.post(apiURL, reqModel).pipe();
  }
  // getCoreUserDetails(transactionID): Observable<any> {
  //   const queryParam = '?transactionID=' + transactionID;
  //   const apiURL = this.baseUrl + this.apiAddress.getCoreUserDetails + '' + queryParam;
  //   return this._http.get(apiURL).pipe();
  // }


  getCoreUserDetails(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getCoreUserDetails;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getPaychexWorkerCommunication(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getPaychexWorkerCommunication;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getContactUserDetails(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getContactUserDetails;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getCompanyUserDetails(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getCompanyUserDetails;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getCoreFeildList(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.getCoreFeildList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getContactFeildList(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.getContactFeildList;
    return this._http.post(apiURL, reqModel).pipe();
  }


  getCompanyFeildList(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.getCompanyFeildList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  geDefaultFilterFieldsList(reqModel): Observable<any> {
    const apiURL = this.baseUrlClm + this.apiAddress.getDefaultFilterFieldsList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  CreateFilter(reqModel): Observable<any> {
    const apiURL = this.baseUrlClm + this.apiAddress.CreateFilter;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getImageUlpoadURL(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getImageUploadURL;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getCoreFieldColumnList(reqModel): Observable<any> {
    const apiURL = this.baseUrlClm + this.apiAddress.getCoreFieldColumn;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getCoreRecentFilter(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getCoreRecentFilter;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAllCoreTypeFilterList(reqModel): Observable<any> {
    const apiURL = this.baseUrlClm + this.apiAddress.GetAllFillters;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getUserPreferences(reqModel): Observable<any> {
    const apiURL = this.baseUrlFilter + this.apiAddress.GetUserPreferences;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // GetUserPreferences(userid): Observable<any> {
  //   const queryParam = '?UserID='+userid;
  //   const apiURL = this.baseUrlFilter + this.apiAddress.GetUserPreferences + '' + queryParam;
  //   return this._http.get(apiURL).pipe();     
  // }

  AddPrefrences(reqModel): Observable<any> {
    const apiURL = this.baseUrlFilter + this.apiAddress.AddPrefrences;
    return this._http.post(apiURL, reqModel).pipe();
  }


  updateCoreFieldColumnList(reqModel): Observable<any> {
    const apiURL = this.baseUrlClm + this.apiAddress.updateCoreFieldColumn;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ReorderCoreFieldColumnList(reqModel): Observable<any> {
    const apiURL = this.baseUrlClm + this.apiAddress.ReorderCoreFieldColumn;
    return this._http.post(apiURL, reqModel).pipe();
  }

  saveCoreFeildList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.saveCoreFieldList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddTaskCustomField(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.AddTaskCustomField;
    return this._http.post(apiURL, reqModel).pipe();
  }

  saveTaskFeildList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.saveCoreFieldList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  saveContactFeildList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.saveContactFieldList;
    return this._http.post(apiURL, reqModel).pipe();
  }
  saveCompanyFeildList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.saveCompanyFieldList;
    return this._http.post(apiURL, reqModel).pipe();
  }
  RemoveGroupRelation(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.RemoveGroupRelation;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetAttachedEntityDocumentFolders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.GetAttachedEntityDocumentFolders;
    return this._http.post(apiURL, reqModel).pipe();
  }
  saveCoreUserDetails(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.saveCoreUserDetails;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetTaskCustomFields(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.GetTaskCustomFields;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateTaskCustomFields(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.UpdateTaskCustomFields;
    return this._http.post(apiURL, reqModel).pipe();
  }

  saveContactUserDetails(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.saveContactUserDetails;
    return this._http.post(apiURL, reqModel).pipe();
  }

  saveCompanyUserDetails(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.saveCompanyUserDetails;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteCoreTransaction(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.DeleteCoreTransaction;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllConditionList(dataModel) {
    const apiCallingURl = this.baseUrlTran + this.apiAddress.GetAllConditionList;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }
  DeleteCondtionsList(dataModel) {
    const apiCallingURl = this.baseUrlTran + this.apiAddress.DeleteConditionByIDs;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  AddUpdateConditionByID(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddUpdateConditionID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllAllergies(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.GetAllAllergyList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllergyByID(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.GetAllAllergyList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateAllergy(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddUpdateAllergyByID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllObservationList(dataModel) {
    const apiURL = this.baseUrlTran + this.apiAddress.GetAllObservationList;
    return this._http.post(apiURL, dataModel).pipe();
  }

  AddUpdateObservationByID(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddUpdateObservationByID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteObservationList(dataModel) {
    const apiURL = this.baseUrlTran + this.apiAddress.DeleteObservationByIDs;
    return this._http.post(apiURL, dataModel).pipe();
  }
  GetAllImmunizationList(dataModel) {
    const apiURL = this.baseUrlTran + this.apiAddress.GetAllImmunizationList;
    return this._http.post(apiURL, dataModel).pipe();
  }

  AddUpdateImmunizationByID(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddUpdateImmunizationByID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteImmunizationList(dataModel) {
    const apiURL = this.baseUrlTran + this.apiAddress.DeleteImmunizationByIDs;
    return this._http.post(apiURL, dataModel).pipe();
  }

  GetAllAllergyList(dataModel) {
    const apiCallingURl = this.baseUrlTran + this.apiAddress.GetAllAllergyList;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  DeleteAllergyList(dataModel) {
    const apiCallingURl = this.baseUrlTran + this.apiAddress.DeleteAllergyByIDs;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  AddUpdateAllergyByID(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddUpdateAllergyByID;
    return this._http.post(apiURL, reqModel).pipe();
  }
  sendToPaychex(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.sendToPaychex;
    return this._http.post(apiURL, reqModel).pipe();
  }

  sendToPendingPatientPCC(reqModel) {
    const apiURL = this.baseUrlTran + this.apiAddress.sendToPendingPatientPCC;
    return this._http.post(apiURL, reqModel).pipe();
  }

  sendToPCC(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.sendToPCC;
    return this._http.post(apiURL, reqModel).pipe();
  }

  sendToPCCCompnay(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.sendToPCCCompany;
    return this._http.post(apiURL, reqModel).pipe();
  }


  FavoriteCoreTransaction(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.FavoriteCoreTransaction;
    return this._http.post(apiURL, reqModel).pipe();
  }
  ImportantCoreTransaction(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.ImportantCoreTransaction;
    return this._http.post(apiURL, reqModel).pipe();
  }


  MakeFilterFavorite(reqModel): Observable<any> {
    const apiURL = this.baseUrlClm + this.apiAddress.MakeFilterFavorite;
    return this._http.post(apiURL, reqModel).pipe();
  }

  RemoveSelectedFilter(reqModel): Observable<any> {
    const apiURL = this.baseUrlClm + this.apiAddress.RemoveSelectedFilter;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetRelationsOfSelectedCores(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.GetRelationsForSelectedCores;
    return this._http.post(apiURL, reqModel).pipe();
  }

  sendBroadcastMsgToRelations(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.SendBroadcastMsgToRelations;
    return this._http.post(apiURL, reqModel).pipe();
  }

  FavoriteDeleteCoreTransaction(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.FavoriteDeleteCoreTransaction;
    return this._http.post(apiURL, reqModel).pipe();
  }
  ImportantDeleteCoreTransaction(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.ImportantDeleteCoreTransaction;
    return this._http.post(apiURL, reqModel).pipe();
  }

  searchTransCities(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.searchTransCities;
    return this._http.post(apiURL, reqModel).pipe();
  }

  searchTransZip(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.searchTransZip;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getStateList(countryId): Observable<any> {
    const apiCallingURl = this.baseURlOrg + this.apiAddress.getStateList;
    return this._http.post(apiCallingURl, countryId).pipe();
  }

  AddCoreTouch(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddCoreTouch;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddCustomInfo(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addCustomInfo;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateCustomInfo(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.updateCustomInfo;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddContactTouch(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddContactTouch;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddCompanyTouch(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddCompanyTouch;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateCoreTouch(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.UpdateCoreTouch;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateContactTouch(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.UpdateContactTouch;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateCompanyTouch(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.UpdateCompanyTouch;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addFileManagerTouch(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addFileManagerTouch;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllCoreTouches(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.GetAllCoreTouches;
    return this._http.post(apiURL, reqModel).pipe();
  }
  DeleteCoreTouch(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.DeleteCoreTouch;
    return this._http.post(apiURL, reqModel).pipe();
  }

   DeleteContactTouch(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.DeleteContactTouch;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteCompanyTouch(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.DeleteCompanyTouch;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetDocumentDetails(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.GetDocumentDetails;
    return this._http.post(apiURL, reqModel).pipe();
  }

  MakeDocumentRequired(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.MakeDocumentRequired;
    return this._http.post(apiURL, reqModel).pipe();
  }

  RenameProjectName(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.RenameProjectName;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ChangeDocumentStatus(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.ChangeDocumentStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ChangeStatusCoreDocumentByReviewer(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.ChangeStatusCoreDocumentByReviewer;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddTouchTypeName(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddTouchTypeName;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addCustomNoteType(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addCustomNoteType;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddFormTouch(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddFormTouch;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ManageFormTemplateCategory(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.ManageFormTemplateCategory;
    return this._http.post(apiURL, reqModel).pipe();
  }

  SearchSubjectTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.SearchSubjectTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddUpdateSubjectMessageTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddUpdateSubjectMessageTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  CheckProjectName(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.CheckProjectName;
    return this._http.post(apiURL, reqModel).pipe();
  }


  GetCCCHtmlFormData(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.GetCCCHtmlFormData;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addTask(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.addTask;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getTaskDetailByID(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskDetailByID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateTaskDetails(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.updateTaskDetail;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeSubTasks(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.removeSubTasks;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeTasks(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.removeTasks;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddCoreMultiDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddCoreMultiDocument;
    return this._http.post(apiURL, reqModel).pipe();
  }


  AddContactMultiDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddContactMultiDocument;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddCompanyMultiDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddCompanyMultiDocument;
    return this._http.post(apiURL, reqModel).pipe();
  }


  getClinicalTemplateCategories(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getClinicalTemplateCategories;
    return this._http.post(apiURL, reqModel).pipe();
  }


  getClinicalTemplateMedication(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getClinicalTemplateMedication;
    return this._http.post(apiURL, reqModel).pipe();
  }
  updateCoreTemplateMedications(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.updateCoreTemplateMedications;
    return this._http.post(apiURL, reqModel).pipe();
  }
  addClinicalTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addClinicalTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }
  updateClinicalTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.updateClinicalTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddTaskMultiDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.AddTaskMultiDocument;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteUploadedDocuments(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.DeleteUploadedDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }

  taskStatus(reqModel): Observable<any> {
    const apiURL = this.baseURlOrg + this.apiAddress.taskStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddTaskCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddTaskCoreURL;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddTaskContact(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddTaskContactURL;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddTaskCompany(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddTaskCompanyURL;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddSavedURL(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddSavedURL;
    return this._http.post(apiURL, reqModel).pipe();
  }

  manageFormTemplateOrganizationCategory(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.manageFormTemplateOrganizationCategory;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getTaskLists(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskLists;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetTaskGroupsByTaskList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.GetTaskGroupsByTaskList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addTaskTemplateCategory(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.addTaskTemplateCategory;
    return this._http.post(apiURL, reqModel).pipe();
  }

  SyncAllWorker(reqModel) {
    const apiURL = this.baseUrlTran + this.apiAddress.syncAllWorker;
    return this._http.post(apiURL, reqModel).pipe();
  }
  setCoreArchive(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.setCoreArchive;
    return this._http.post(apiURL, reqModel).pipe();
  }

  setCoreActivate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.setCoreActivate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateTaskListGridCustomizedSetting(reqModel): Observable<any> {
    const apiURL = this.baseUrlClm + this.apiAddress.updateTaskListGridCustomizedSetting;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addUserKanbanView(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addUserKanbanView;
    return this._http.post(apiURL, reqModel).pipe();
  }

  changeCoreStatus(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.changeCoreStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getCoreFieldValue(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getCoreFieldValue;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddActivityForPortal(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addActivityForPortal;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
    // const apiURL = this.baseUrlTran + this.apiAddress.addActivityForPortal;
    // return this._http.post(apiURL, reqModel).pipe();
  }

  getAllToucheStatus(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getAllToucheStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAllCustomInfoStatus(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getAllCustomInfoStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddAllergiesPCC(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddAllergiesPCC;
    return this._http.post(apiURL, reqModel).pipe();
  }
  runAutomationForAIToolForClinical(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.runAutomationForAIToolForClinical;
    return this._http.post(apiURL, reqModel).pipe();
  }
  RunAIClinical(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddAllergiesPCC;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddImmunizationsPCC(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddImmunizationsPCC;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddConditionsPCC(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddConditionsPCC;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddObservationPCC(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddObservationPCC;
    return this._http.post(apiURL, reqModel).pipe();
  }


  addTouchStatus(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addTouchStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addOCRTemplateCategory(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addOCRTemplateCategory;
    return this._http.post(apiURL, reqModel).pipe();
  }

  SendActivityEMailCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.SendActivityEMailCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  SendActivityEMailContact(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.SendActivityEMailContact;
    return this._http.post(apiURL, reqModel).pipe();
  }

  SendActivityEMailCompany(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.SendActivityEMailCompany;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAllTagsList(dataModel) {
    const apiCallingURl = this.baseUrlTran + this.apiAddress.getAllTagList;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getAllFieldsCore(dataModel) {
    const apiCallingURl = this.baseCoreUrl + this.apiAddress.getAllFolderFields;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  addTicketTask(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.addTicketTask;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getOfficeMailConfigration(reqModel): Observable<any> {
    const apiURL = this.baseURlOrg + this.apiAddress.getOfficeMailConfigration;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addNLPTemplateCategory(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addNLPTemplateCategory;
    return this._http.post(apiURL, reqModel).pipe();
  }
  addClinicalTemplateCategory(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addClinicalTemplateCategory;
    return this._http.post(apiURL, reqModel).pipe();
  }
  getClinicalTemplates(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getClinicalTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }


  getHtmlFormData(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getHtmlFormData;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addCustomInfoStatus(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addCustomInfoStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addWebFormUserSetting(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addWebFormUserSetting;
    return this._http.post(apiURL, reqModel).pipe();
  }

  unMappedTouchesTypes(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.unMappedTouchesTypes;
    return this._http.post(apiURL, reqModel).pipe();
  }

  unMappedtCustomInfoTypes(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.unMappedtCustomInfoTypes;
    return this._http.post(apiURL, reqModel).pipe();
  }


  renamecoreplaceholder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.renamecoreplaceholder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  submit_prompt_4o_onGivenContext_New(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.submit_prompt_4o_onGivenContext_New;
    return this._http.post(apiURL, reqModel).pipe();
  }

  //Not Working
  submit_prompt_4o_onGivenContext(prompt_input: string): Observable<any> {
    const apiURL = 'https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/submit-prompt-4o-onGivenContext';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      prompt: prompt_input
    };
    return this._http.post(apiURL, body, { headers, observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, response: response.body['response'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }

  GetAllContactTouches(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.GetAllContactTouches;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllCompanyTouches(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.GetAllCompanyTouches;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getDashboardProcessStages(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getDashboardProcessStages;
    return this._http.post(apiURL, reqModel).pipe();
  }
  getAllActiveStages(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getAllActiveStages;
    return this._http.post(apiURL, reqModel).pipe();
  }

  setProcessStageforTaskTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.setProcessStageforTaskTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  setProcessStagetoDocumentFolderTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.setProcessStagetoDocumentFolderTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  setProcessStageforTasklistGroup(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.setProcessStageforTasklistGroup;
    return this._http.post(apiURL, reqModel).pipe();
  }

  setProcessStageForCoreDocumentFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.setProcessStageForCoreDocumentFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  reorderTaskGroup(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.reorderTaskGroup;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeTaskGroup(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.removeTaskGroup;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addEditTaskGroup(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.addEditTaskGroup;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateTaskStatus(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.UpdateTaskStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  makeTaskRequired(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.makeTaskRequired;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateSingleTaskStatus(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.UpdateSingleTaskStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateTaskOrTaskListstatus(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.UpdateTaskOrTaskListstatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateTaskPriority(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.UpdateTaskPriority;
    return this._http.post(apiURL, reqModel).pipe();
  }

  archivedTask(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.archivedTask;
    return this._http.post(apiURL, reqModel).pipe();
  }

  deleteMedicationByIDs(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.deleteMedicationByIDs;
    return this._http.post(apiURL, reqModel).pipe();
  }


  SendManualTaskReminderService(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.sendManualReminderforTask;
    return this._http.post(apiURL, reqModel).pipe();
  }
  getNormalAndSharedContacts(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getNormalAndSharedContacts;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddCreateProjectforPlaceholder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddCreateProjectforPlaceholder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectInfoAsTemplete(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddProjectInfoAsTemplete;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectEventLog(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddProjectEventLog;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddEditProjectGroupRelationParticipant(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.AddEditProjectGroupRelationParticipant;
    return this._http.post(apiURL, reqModel).pipe();
  }

  sendCoreEducationalMaterialToContacts(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.sendCoreEducationalMaterialToContacts;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getConditionsForCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getConditionsForCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getCoreEducationalMaterial(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getCoreEducationalMaterial;
    return this._http.post(apiURL, reqModel).pipe();
  }

  preparePersonalMessage(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran +
      (this.apiAddress.preparePersonalMessage || 'api/AIAutomation/PreparePersonalMessage');
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAIAutomationTemplates(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getAIAutomationTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }

  uploadChunk(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.uploadChunk;
    return this._http.post(apiURL, reqModel).pipe();
  }

  uploadChunkForMultipleUploadWithSelectedTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.uploadChunkForMultipleUploadWithSelectedTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getInboxProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getInboxProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getSentProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getSentProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getDraftedProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getDraftedProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  changeMedicalCategoryForCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.changeMedicalCategoryForCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  changeProcessStageForCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.changeProcessStageForCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  uploadChunkForMultipleFiles(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.uploadChunkForMultipleFiles;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addIncomeForPDPMCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addIncomeForPDPMCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addAssetForPDPMCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addAssetForPDPMCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addExpenseForPDPMCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addExpenseForPDPMCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAccountingforPDPMCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getAccountingforPDPMCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeIncomeforPDPMCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.removeIncomeforPDPMCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeAssetforPDPMCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.removeAssetforPDPMCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeExpenseforPDPMCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.removeExpenseforPDPMCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addPNAadResourceLimit(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addPNAadResourceLimit;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addReferralTemplateCategory(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addReferralTemplateCategory;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getReferralTemplateCategories(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getReferralTemplateCategories;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addUpdateThresholdRules(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addUpdateThresholdRules;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getThresholdRules(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getThresholdRules;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getReferralQuestionAnswers(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getReferralQuestionAnswers;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addReferralTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addReferralTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getReferralTemplates(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getReferralTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }

  importReferralTemplateFromAOffice(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.importReferralTemplateFromAOffice;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateReferralTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.updateReferralTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateThresholdRule(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.updateThresholdRule;
    return this._http.post(apiURL, reqModel).pipe();
  }

   updateThresholdRules(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.updateThresholdRules;
    return this._http.post(apiURL, reqModel).pipe();
  }

  importReferralQuestionsFromTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.importReferralQuestionsFromTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }


  getActiveReferralLocations(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getActiveReferralLocations;
    return this._http.get(apiURL, {
      params: reqModel
    });
  }

   associateLocationWithReferralQueue(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.associateLocationWithReferralQueue;
    return this._http.post(apiURL, reqModel).pipe();
  }

   canThisPdfOpenforModifyByBytes(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.canThisPdfOpenforModifyByBytes;
    return this._http.post(apiURL, reqModel).pipe();
   }

    getCoreSelectedCores(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getCoreSelectedCores;
    return this._http.post(apiURL, reqModel).pipe();
  }

    getNormalAndSharedCompanys(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getNormalAndSharedCompanys;
    return this._http.post(apiURL, reqModel).pipe();
  }

   addUpdateCoresToCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addUpdateCoresToCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addUpdateCoreContact(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addUpdateCoreContact;
    return this._http.post(apiURL, reqModel).pipe();
  }

   addUpdateCoreCompany(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addUpdateCoreCompany;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addProjectRequests(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addProjectRequests;
    return this._http.post(apiURL, reqModel).pipe();
  }

   getAllParticipantsForProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getAllParticipantsForProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addParticipantsForProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addParticipantsForProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

   addUpdateCoreContactRole(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addUpdateCoreContactRole;
    return this._http.post(apiURL, reqModel).pipe();
  }

   addUpdateCoreCompanyRole(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addUpdateCoreCompanyRole;
    return this._http.post(apiURL, reqModel).pipe();
  }

   addMemoryCardCategory(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addMemoryCardCategory;
    return this._http.post(apiURL, reqModel).pipe();
  }

   getMemoryCardCategories(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getMemoryCardCategories;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addMemoryCard(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addMemoryCard;
    return this._http.post(apiURL, reqModel).pipe();
  }

   getMemoryCards(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getMemoryCards;
    return this._http.post(apiURL, reqModel).pipe();
  }

   addMemoryCardToReferralQuestion(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addMemoryCardToReferralQuestion;
    return this._http.post(apiURL, reqModel).pipe();
  }
  
   addFileNote(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.addFileNote;
    return this._http.post(apiURL, reqModel).pipe();
  }

  deleteFileNote (reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseUrlTran + this.apiAddress.deleteFileNote;
    return this._http.delete(apiURL, options).pipe();
  }

  GetContactListCoreImplementation(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.GetContactListCoreImplementation;
    return this._http.post(apiURL, reqModel).pipe();
  }
}


